module.exports = __webpack_public_path__ + "static/img/3-design-b2.b1c095f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-design-b2.jpg
// module id = cmYL
// module chunks = 0